@use 'kci-design-lib/styles/variables.scss' as *;
.notification {
  display: flex;
  justify-content: center;
  align-items: center;
}
.message {
  border: none;
  margin: 0;
}
.toast {
  opacity: 1;
  max-width: 444px;
  z-index: 10000;
  font-family: $font-family;
  .description {
    margin-top: 4px;
    color: var(--text-subtle-strong);
    font-size: 14px;
    word-break: break-word;
    white-space: normal;
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .notification-text {
    margin: 0;
    min-width: 0;
    flex: 1 1 auto;
  }
  [data-pc-section='messageicon'] {
    width: 40px;
    height: 40px;
    border-radius: 40px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  [data-pc-section='messageicon'] img,
  .content > img:first-child {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 40px;
    flex-shrink: 0;
  }
  .notification-icon {
    width: 40px;
    height: 40px;
    border: 8px solid transparent;
    border-radius: 40px;
    flex-shrink: 0; 
  }
  .notification-icon-img {
    display: block;
  }
  .title {
    color: var(--text-emphasis);
    font-weight: 700;
    font-size: 16px;
    word-break: break-word;
    white-space: normal;
    line-height: 160%;
    display: block;
  }
  .content {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .message {
    box-shadow: none;
    border-radius: 4px;
  }
  .close-button {
    background: none;
    border-radius: 4px;
    font-family: $font-family;
    flex-shrink: 0;
    svg {
      min-width: 14px;
      width: 14px;
      height: 14px;
      display: none;
    }
  }
  &.info {
    .message {
      background-color: var(--surface-feedback-info);
      border: 1px solid var(--border-feedback-info);
    }
    .close-button {
      color: var(--text-action-info);
      background-image: url('../../../assets/Icons/Notification/info-close.svg');
      filter: var(--filter-feedback-info);
      &:hover {
        border: 1px solid var(--text-action-info);
        background-image: url('../../../assets/Icons/Notification/info-close-hover.svg');
      }
    }
    [data-pc-section='messageicon'] img,
    .content > img:first-child {
      filter: var(--filter-feedback-info);
    }
    &.hover {
      .close-button {
        border: 1px solid $sbl-text;
        background-image: url('../../../assets/Icons/Notification/info-close-hover.svg');
      }
    }
  }
  &.success {
    .message {
      background-color: var(--surface-feedback-success);
      border: 1px solid var(--border-feedback-success);
    }
    .close-button {
      color: var(--text-action-success);
      background-image: url('../../../assets/Icons/Notification/success-close.svg');
      filter: var(--filter-feedback-success);
      &:hover {
        border: 1px solid var(--text-action-success);
        background-image: url('../../../assets/Icons/Notification/success-close-hover.svg');
      }
    }
    [data-pc-section='messageicon'] img,
    .content > img:first-child {
      filter: var(--filter-feedback-success);
    }
    &.hover {
      .close-button {
        border: 1px solid $icon-success;
        background-image: url('../../../assets/Icons/Notification/success-close-hover.svg');
      }
    }
  }
  &.warn {
    .message {
      background-color: var(--surface-feedback-warning);
      border: 1px solid var(--border-feedback-warning);
    }
    .close-button {
      color: var(--text-action-warning);
      background-image: url('../../../assets/Icons/Notification/warning-close.svg');
      filter: var(--filter-feedback-warning);
      &:hover {
        border: 1px solid var(--text-action-warning);
        background-image: url('../../../assets/Icons/Notification/warning-close-hover.svg');
      }
    }
    [data-pc-section='messageicon'] img,
    .content > img:first-child {
      filter: var(--filter-feedback-warning);
    }
    &.hover {
      .close-button {
        border: 1px solid $icon-warning;
        background-image: url('../../../assets/Icons/Notification/warning-close-hover.svg');
      }
    }
  }
  &.error {
    .message {
      background-color: var(--surface-feedback-error);
      border: 1px solid var(--border-feedback-error);
    }
    .close-button {
      color: var(--text-action-error);
      background-image: url('../../../assets/Icons/Notification/error-close.svg');
      filter: var(--filter-feedback-error);
      &:hover {
        border: 1px solid var(--text-action-error);
        background-image: url('../../../assets/Icons/Notification/error-close-hover.svg');
      }
    }
    [data-pc-section='messageicon'] img,
    .content > img:first-child {
      filter: var(--filter-feedback-error);
    }
    &.hover {
      .close-button {
        border: 1px solid $icon-error;
        background-image: url('../../../assets/Icons/Notification/error-close-hover.svg');
      }
    }
  }
  &.text-closable {
    width: 444px;
    .close-button {
      width: unset;
      border-radius: 0px;
      font-weight: 600;
      font-size: 14px;
      border-bottom: 1px solid transparent;
      height: unset;
      min-height: 32px;
      line-height: 20px;
      letter-spacing: 0.2px;
      background-image: none;
      padding: 6px 4px;
      &::before {
        content: attr(data-label);
      }
      &:hover {
        border-top: none;
        border-left: none;
        border-right: none;
        background-image: none;
      }
    }
    &.hover {
      .close-button {
        border-top: none;
        border-left: none;
        border-right: none;
        background-image: none;
      }
    }
  }
  &.icon-closable {
    width: 414px;
    .close-button {
      width: 32px;
      height: 32px;
      border: none;
      background-repeat: no-repeat;
      background-position: center;
      content: '';
      display: inline-block;
      &:hover {
        border: none;
      }
      &:not(:hover) {
        background-size: 14px 14px;
      }
    }
    &.hover {
      .close-button {
        border: none;
        background-size: unset;
      }
    }
  }
  &.autoclose {
    width: 334px;
    .notification-text {
      margin: 0;
      &+div {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .toast {
    &.text-closable,
    &.icon-closable,
    &.autoclose {
      width: unset;
    }
  }
}
.toast.text-closable .close-button {
  color: var(--text-subtle-strong);
}

html[data-theme='dark'] {
  .toast {
    .description {
      color: $color-text-disabled;
    }
  }
}

[data-theme='dark'] {
  .toast {
    .description {
      color: $color-text-disabled;
    }
  }
}
